import React from "react";

const EmptyCard = ({
  styles = {},
  text = {},
  language = "en",
  title = null,
  children,
  className = "",
  userName = null,
  titleAlign = "left", // left|center|right
  actionsAlign = "flex-end", // flex-start|center|flex-end
  containerStyle = {},
  actionsStyle = {},
  hideTitle = false,
}) => {
  const getStoredFirstName = () => {
    if (userName) return userName;
    const stored = language === "ar" ? localStorage.getItem("employeeArabicName") : localStorage.getItem("employeeName");
    return (stored && stored.split(" ")[0]) || "";
  };

  const computeTitle = () => {
    if (title) {
      if (typeof title === "object") return title[language] || title.en || Object.values(title)[0];
      const titleStr = String(title || "").trim();
      return titleStr || "";
    }

    if (text && text[language] && text[language].title) return text[language].title;

    const name = getStoredFirstName();
    const welcomeText = text && text[language] && text[language].welcome ? text[language].welcome : null;
    return welcomeText ? `${welcomeText}, ${name}` : (name || "");
  };

  const displayTitle = computeTitle();

  const defaultCard = {
    background: "transparent",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px solid rgba(0,0,0,0.06)",
    display: "block",
  };

  const mergedStyles = {
    welcomeCard: { ...(styles.welcomeCard || styles.statCard || defaultCard), ...containerStyle },
    welcomeSection: {
      ...(styles.welcomeSection || { display: "flex", alignItems: "center", justifyContent: "space-between" }),
    },
    welcomeTitle: {
      ...(styles.welcomeTitle || { margin: 0, fontSize: "1.25rem", fontWeight: 700 }),
      textAlign: titleAlign,
    },
    actionsWrapper: { display: "flex", gap: "8px", alignItems: "center", justifyContent: actionsAlign, ...actionsStyle },
  };

  return (
    <div style={mergedStyles.welcomeCard} className={className}>
      <div style={mergedStyles.welcomeSection}>
        {!hideTitle && <h1 style={mergedStyles.welcomeTitle}>{displayTitle}</h1>}
        <div style={mergedStyles.actionsWrapper}>{children}</div>
      </div>
    </div>
  );
};


export default EmptyCard;
